const APP_PREFIX = 'nlp-portal'

export const LocalStorageKeys = {
  DARK_MODE: `${APP_PREFIX}-dark-mode`,
  MESSAGE_DEBUG_PANELS: `${APP_PREFIX}-message-debug-panels`,
  PROCESS_DEBUG_CONTENT_PANELS: `${APP_PREFIX}-process-debug-content-panels`,
}
